import React from 'react';

interface ThemeContextInterface {
  currentTheme: string;
  setTheme: (theme: string) => void;
}

export const ThemeContext = React.createContext<ThemeContextInterface>({
  currentTheme: 'light',
  setTheme: () => null,
});

export default ThemeContext;
